var exports = {
  "Q": "MessagesTab.module__switchWrapper___S192Nz",
};

module.exports = exports;
